export default __webpack_public_path__ + "static/media/bbotLogo.88dee8a4.svg";